import { MainNav } from "@portal/components/ui/MainNav";

export const AgentMainNav = () => (
	<MainNav
		items={{
			dashboard: true,
			requests: true,
			bonds: true,
			accounts: true,
			submissions: true,
		}}
	/>
);
